<template>
  <div
    class="
      xl:w-4/5
      md:w-11/12
      xl:my-10
      md:my-4
      md:mx-auto
      m-1
      bg-gray-50
      rounded
    "
  >
    <EditForm
      :row="Array(headings.length)"
      :headers="headings"
      :submitEdit="submitEdit"
      v-if="show"
    />
    <div class="flex flex-row justify-center p-4 w-full">
      <div class="flex ml-auto">
        <div>
          <h1 class="font-semibold xl:text-xl ">Manage Option Rules</h1>
        </div>
      </div>
      <t-button
          variant="success"
          class="float-right ml-auto"
          @click="show = true"
          >Insert New Record</t-button
        >
    </div>
    <div class="p-4 w-auto">
      <t-alert variant="info" show v-on:hidden="setCookie" v-if="noCookie()">
        THERE IS A LOT OF COURSE/MODULE COMBINATIONS SO GIVE THIS A HOT MINUTE;
        USE CONTROL-F IF YOU KNOW WHAT TO LOOK FOR.
        <br />
        There is too many fields to display horizontally.
        <br />
        prog_code: the ucas_code from programmes
        <br />
        title of programme (computed from prog_code, edits discarded)
        <br />
        entry_year: the year the student joined RHUL
        <br />
        stage: the current stage (year) of the student
        <br />
        constraint_type: one of CORE, OPTS, STRAND, DISC_ALT, DISALLOWED,
        CREDITS, MAX_STRAND (see below)
        <br />
        min_quantity: how many modules / credits must match this rule
        <br />
        max_quantity: how many modules / credits can at most match this rule
        <br />
        mod_code_pattern: comma separated list of module codes or prefixes or
        strand name
      </t-alert>
    </div>
    <div class="flex">
    <Table
      :items="items"
      :del="del"
      :edit="edit"
      :getTheDataInParent="getData"
    />
    </div>
  </div>
</template>

<script>
import Table from './Table';
import EditForm from './EditForm';

export default {
  components: {
    Table,
    EditForm,
  },
  created() {
    this.getData();
  },
  methods: {
    async edit(oldRow, newRow) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/edit_option_rule_row`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            oldRow: oldRow,
            newRow: newRow,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },
    async del(row) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/del_course`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            row: row,
            jwt: localStorage.getItem('jwt'),
          })
        },
      );
      return await res;
    },
    async getData() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_courses`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            'jwt': localStorage.getItem('jwt'),
          }),
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.items = response.data;
          this.getHeadings();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getHeadings: function() {
      try {
        const i = Object.keys(this.items).map((key) => {
          return [Number(key), this.items[key]];
        });

        this.headings = Object.keys(i[0][1]);
        console.log(this.headings);
      } catch (_e) {}
    },
    submitEdit(edit) {
      if (edit === 'cancel') {
        this.show = false;
        return;
      }

      console.log(edit);
      this.show = false;

      this.insert(edit).then((res) => {
        if (res.ok) {
          console.log(res);
          this.$vToastify.success('Successfully carried out edit');
          this.getData();
        } else {
          this.$vToastify.error('Could not edit, see console for details');
          console.error(res);
        }
      });
    },

    async insert(edit) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/insert_option_rule_row`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            edit: edit,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },
    setCookie() {
      this.$cookies.set('ManageOptionRules-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('ManageOptionRules-infobox') === 'dismissed');
    },
  },
  data() {
    return {
      headings: [],
      show: false,
      items: [],
    };
  },
};
</script>

<style></style>
